<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    max-width="500"
    style="z-index: 2000"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular text-truncate"
      >
        <span
          v-if="
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress == 100
          "
        >
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-2"
            medium
            >mdi-cloud-check</v-icon
          >
          {{ $t("userNewOrderBasicOrderCompleted") }}
        </span>
        <span v-else>
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-3"
            medium
            >mdi-timer-sand</v-icon
          >
          {{ $t("lmPleaseWait") }}
        </span>
      </v-card-title>
      <v-card-text class="pt-6 pb-1">
        <div
          v-if="
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress < 100 &&
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress > 0
          "
        >
          <p class="overline">
            {{ $t("userNewOrderOrderSending1Title") }}
          </p>
          <v-progress-circular
            rotate="360"
            size="150"
            width="25"
            v-model="
              $store.state.storeModPhotoOrderUploadService.uploadProgress
                .progress
            "
            color="primary"
          >
            {{
              $store.state.storeModPhotoOrderUploadService.uploadProgress
                .progress
            }}%
          </v-progress-circular>
          <div class="ma-3">
            <p>
              {{
                $store.state.storeModPhotoOrderUploadService.uploadProgress
                  .bytesTransferred
              }}
              /
              {{
                $store.state.storeModPhotoOrderUploadService.uploadProgress
                  .totalBytes
              }}
            </p>
          </div>
        </div>
        <div
          v-else-if="
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress == 100
          "
        >
          <p class="overline ma-0">
            <v-icon medium color="primary" class="mr-2">mdi-check-bold</v-icon
            ><span
              v-if="$store.state.storePhotoGiftOrderDesign.superType == 4"
              >{{ $t("userNewOrderOrderCompleteGiftCardTitle") }}</span
            >
            <span v-else>{{ $t("userNewOrderOrderComplete2Title") }}</span>
          </p>
          <p class="title-2 mt-4">
            <v-icon color="accent" class="mr-2">mdi-chat-alert-outline</v-icon
            >{{ $t("userNewOrderOrderComplete1Title") }}
          </p>
        </div>
        <div v-else>
          <p class="overline">
            {{ $t("userNewOrderPreparingPackageTitle") }}
          </p>
          <v-progress-circular
            rotate="360"
            size="150"
            width="25"
            v-model="
              $store.state.storeModPhotoOrderUploadService.generatingZipProgress
                .progress
            "
            color="primary"
          >
            {{
              $store.state.storeModPhotoOrderUploadService.generatingZipProgress
                .progress
            }}%
          </v-progress-circular>
          <div class="ma-3">
            <p>
              {{
                $store.state.storeModPhotoOrderUploadService
                  .generatingZipProgress.currentFile
              }}
            </p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <div
          v-if="
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress < 100 &&
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress > 0
          "
        >
          <v-btn color="primary" text class="mx-0" @click="clickCancel">{{
            $t("userNewOrderBasicBtnCancelOrder")
          }}</v-btn>
        </div>
        <div
          v-else-if="
            $store.state.storeModPhotoOrderUploadService.uploadProgress
              .progress == 100
          "
          class="d-flex flex-no-wrap"
        >
          <v-btn color="primary" text @click="clickNewOrder">
            <v-icon class="mr-2">mdi-image-multiple</v-icon>
            {{ $t("userNewOrderBasicNewPackage") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$router.push({ name: 'userCart' })"
          >
            <v-icon class="mr-2">mdi-cart</v-icon>
            {{ $t("commonNewOrderOrderEndShoppingTitle") }}
          </v-btn>
        </div>
        <div v-else>
          <v-btn color="primary" text class="mx-0" @click="clickCancel">{{
            $t("userNewOrderBasicBtnCancelOrder")
          }}</v-btn>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-upload",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    clickNewOrder() {
      this.$emit("clickNewOrder");
    },
    clickCancel() {
      location.reload(true);
    },
  },
};
</script>

<style scoped>
</style>